import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import clsx from 'clsx'
import '../../../style/style.css'

type Props = {
  title: string
  url?: string | undefined
  hasArrow?: boolean
}

const MenuItem: FC<Props> = ({ title, url = undefined, hasArrow = false }) => {
  const navigate = useNavigate();

  return (
    <div className='menu-item me-lg-1'>
      <a
        className={clsx(`menu-link py-3 ${url? 'pe-auto' : 'pe-none'}`)}
        title={title}
      >
        {hasArrow &&
          <span onClick={() => url ? window.location.href = url : navigate(-1)} className='menu-icon'>
            <img src='/media/icons/arrow-left.svg' />
          </span>
        }
        <span className='masterHeaderTitle'>{title}</span>
      </a>
    </div>
  )
}

export { MenuItem }
